import { render, staticRenderFns } from "./ServiceTypeComponent.vue?vue&type=template&id=910f1778"
import script from "./ServiceTypeComponent.vue?vue&type=script&lang=js"
export * from "./ServiceTypeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports